 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		53: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		53: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app/" + ({"2":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"vendors~Assessments~GoalDetails~LearnosityEduAuthor~MemberHomepage~ProgressTracker","4":"AssignmentsModal~AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","5":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","6":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","8":"LandingPage~Pricing","9":"RegistrationModal~SwitchAccountModal","10":"vendors~Checkout~Gift","12":"AccountSettings","13":"Assessments","14":"Assignments","15":"AssignmentsModal","16":"AssignmentsModalV2","17":"AssignmentsV2","18":"BackToSchoolBundle","19":"BrainzyPaint","20":"Checkout","21":"FeaturedArtwork","22":"Gift","23":"GoalDetails","24":"GradeFilteredContentCards","25":"GradeWorksheetModal","26":"HomeLearning","27":"KidFrame","28":"KidFrameDetail","29":"LandingPage","30":"LearnosityEduAuthor","31":"MemberHomepage","32":"MyCollections","33":"MyStudents","34":"Onboarding","35":"PracticeSkill","36":"PredefinedCollectionsDetail","37":"Pricing","38":"ProgressTracker","39":"RegistrationModal","40":"RelatedGuidedLesson","41":"Reviews","42":"SeasonalDaysDropdown","43":"Sellpage","44":"SubPlansList","45":"SwitchAccountModal","46":"TakeAssessmentModal","47":"vendors~AssignmentsV2","48":"vendors~Checkout","49":"vendors~Gift","50":"vendors~MemberHomepage","51":"vendors~MyStudents","52":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"4c42110799be9846b7ce","1":"387951d0082e1ed68c0a","2":"9e8db2c50dd887522f86","3":"9113fc929508cef1c22b","4":"e66f6fe9a770b37b0750","5":"a375234a55928d08e5bf","6":"82d2e67b88498a1aaad1","7":"a965658be4212f6f1a08","8":"b7246031a2f034afb7c1","9":"b56bfa5d03b5159715b6","10":"981ba376b0a18a4e9d29","11":"4aa77705fc8850868b8e","12":"d0c49773f5ea093cf75b","13":"2563b90f76df09923cd7","14":"3588dc9cee2fa9f8e8b3","15":"77f65b647325b499f178","16":"5dfb7cb4d459a001b048","17":"b6661f7ed73b8f5975eb","18":"c30f1035e96c7d433844","19":"1d884c7ad9c26231abde","20":"35e120d887a71c3f7a91","21":"0d8adb4a7f155327d2b0","22":"76786da556060bcd5738","23":"530770a993620bedf0e5","24":"79a28128a931f1ccdbb7","25":"280a27c1a0fb1e93e540","26":"039910b5e51e92d55fff","27":"972a0f62f9eb204a37cd","28":"5637a9f555b944fbfcee","29":"c42615eeb751a5eb221f","30":"60fdf7d7c7d600c90455","31":"e830ec92f9132c6f6054","32":"cb7739ade94f94b823ae","33":"21417d38a97ac96ba2fd","34":"faaa03bda1512c528082","35":"c92f88f396f35594b3e7","36":"d3a6d98499b6b525ee79","37":"2e910bab2c9c9697bbae","38":"d2b6a7d02f42f4046b69","39":"ad6f3babe9e81d02a4ad","40":"01280398b14e34f375a6","41":"0ef6ec1ea1f217bdcd13","42":"37b92ecdb198f723142f","43":"f551baeabcd8e8fbf67a","44":"2b95159bfda88ad2aef2","45":"996d0122f9259fa93b63","46":"cdfd325c169ac058d1d1","47":"476a77bc244658d0eef2","48":"a7a9ca445bdfc2d56635","49":"fe0e273a4e9b270468b1","50":"3c75b97630dcb81498bd","51":"2a2360770bfc80a300c1","52":"2f96d846ec34363a41a1","55":"9055f0c21cab9a4fd0e4","56":"d079af0059aa45910d26"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"4":1,"8":1,"9":1,"12":1,"13":1,"15":1,"16":1,"17":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"37":1,"38":1,"41":1,"42":1,"43":1,"46":1,"49":1,"55":1,"56":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app/" + ({"2":"vendors~Assessments~Gift~GoalDetails~KidFrame~MyStudents","3":"vendors~Assessments~GoalDetails~LearnosityEduAuthor~MemberHomepage~ProgressTracker","4":"AssignmentsModal~AssignmentsModalV2~KidFrameDetail~TakeAssessmentModal","5":"AssignmentsV2~HomeLearning~PredefinedCollectionsDetail~SubPlansList","6":"vendors~Assessments~MyStudents~RegistrationModal~SwitchAccountModal","8":"LandingPage~Pricing","9":"RegistrationModal~SwitchAccountModal","10":"vendors~Checkout~Gift","12":"AccountSettings","13":"Assessments","14":"Assignments","15":"AssignmentsModal","16":"AssignmentsModalV2","17":"AssignmentsV2","18":"BackToSchoolBundle","19":"BrainzyPaint","20":"Checkout","21":"FeaturedArtwork","22":"Gift","23":"GoalDetails","24":"GradeFilteredContentCards","25":"GradeWorksheetModal","26":"HomeLearning","27":"KidFrame","28":"KidFrameDetail","29":"LandingPage","30":"LearnosityEduAuthor","31":"MemberHomepage","32":"MyCollections","33":"MyStudents","34":"Onboarding","35":"PracticeSkill","36":"PredefinedCollectionsDetail","37":"Pricing","38":"ProgressTracker","39":"RegistrationModal","40":"RelatedGuidedLesson","41":"Reviews","42":"SeasonalDaysDropdown","43":"Sellpage","44":"SubPlansList","45":"SwitchAccountModal","46":"TakeAssessmentModal","47":"vendors~AssignmentsV2","48":"vendors~Checkout","49":"vendors~Gift","50":"vendors~MemberHomepage","51":"vendors~MyStudents","52":"vendors~ProgressTracker"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"d9a40cf5055131673016","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"d83f7d79e0dedcc0dc59","9":"48c7bd2961fd350bb74d","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"4ad35bb3dca41c2cae0b","13":"319cc6fee30abd4ab2b0","14":"31d6cfe0d16ae931b73c","15":"873810f5a6a42c5b4f08","16":"eb2214ca25d23a3b9585","17":"a85ed26ea09a0cf62c2b","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"9b178eec9c3cf73696c2","21":"d56d9288e4c0c7368f48","22":"7c9ade4d0722da2d712c","23":"ba6307e6a97b2de53684","24":"83e0046bc0ea33eabf0e","25":"fd2c2b017f0caffc689f","26":"4c89bea8f7f35505c32a","27":"28e4524fec676874d266","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"8ad20e7a95d214ad9a49","31":"6575f2d494e3a4795f9f","32":"ab19f0324e469dc86f86","33":"453c47aded92a96201c6","34":"c690fa1aa61d12f8135c","35":"5491656ee574e8b4a49d","36":"31d6cfe0d16ae931b73c","37":"1320f4897b7b95eaec24","38":"9a4d3c6e9d50e0425e0e","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"3eb70bdfce6885905434","42":"eaafc727492eb4363427","43":"ba010189d2bfdd022601","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"bf40f2159a5c06b0446f","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"ca68f8fa1dd9edae64fc","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","55":"c7c112df630d782cdeed","56":"c7c112df630d782cdeed"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([397,54]);
 	// run deferred modules when ready
 	return checkDeferredModules();
